import NextLink from 'next/link';
import { FC } from 'react';

import { LogoIcon, LogoTextIcon } from '../../icons';

import styles from './Logo.module.scss';

export const Logo: FC = () => {
  return (
    <NextLink className={styles.brandLogo} href="/">
      <span className={styles.brandLogoText}>
        <LogoTextIcon />
      </span>
      <span className={styles.brandLogoIcon}>
        <LogoIcon />
      </span>
    </NextLink>
  );
};
